export const pricingPlan = [
	'reviewCenter',
	'unlimitedProjects',
	'collaborativeOnlineEditor',
	'automationsRules',
	'screenshots',
	'tasks',
	'branching',
	'chainedTasks',
	'taskLocks',
	'inlineMachineTranslation',
	'translationMemory',
	'tmManagement',
	'translationHistory',
	'spellingGrammar',
	'glossary',
	'sharedGlossary',
	'userGroups',
	'webInContextEditor',
	'mobileSdk',
	'mobileInsights',
	'apiCli',
	'languageAutoFill',
	'projectActivity',
	'translatorsStats',
	'autoSnapshots',
	'pagedDocuments',
	'customStatuses',
	'auditLogs',
	'vendorRateProfiles',
	'webhooks',
	'customProcessor',
	'slack',
	'trello',
	'jira',
	'asana',
	'zapier',
	'gitHubGitLabBitbucket',
	'gitHubEnterprise',
	'bitbucketEnterprise',
	'azureRepos',
	'wordPress',
	'hubSpot',
	'brazeIterable',
	'freshdesk',
	'typeform',
	'marketo',
	'webflow',
	'contentful',
	'storyblok',
	'contentstack',
	'salesforce',
	'sketchFigmaAdobeXd',
	'zendeskIntercom',
	'amazonS3',
	'googleCloudStorage',
	'singleSignOnSaml2fa',
	'initialSetUp',
	'implementationSupport',
	'dedicatedManager',
	'personalOnboarding',
	'uptimeGuarantee99',
	'basicSupport',
	'prioritySupport',
	'otaGb',
	'hostedKeys',
	'automationsActions',
] as const

export type PricingPlanKey = (typeof pricingPlan)[number]
